// src/features/invoice/components/InvoiceStats.jsx
import React from "react";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  LinearProgress,
} from "@mui/material";

import {
  Receipt,
  CheckCircle,
  Pending,
  Warning,
  TrendingUp,
  AttachMoney,
  Schedule,
} from "@mui/icons-material";
import { formatCurrency } from "../utils/invoiceHelpers";

const InvoiceStats = ({ stats }) => {
  const defaultStats = {
    total: 0,
    draft: 0,
    sent: 0,
    viewed: 0,
    paid: 0,
    partially_paid: 0,
    overdue: 0,
    cancelled: 0,
    refunded: 0,
    totalValue: 0,
    totalPaid: 0,
    totalOutstanding: 0,
    averageValue: 0,
    collectionRate: 0,
    overdueCount: 0,
  };

  const data = stats || defaultStats;

  const statCards = [
    {
      title: "Total Invoices",
      value: data.total,
      icon: <Receipt sx={{ fontSize: 32 }} />,
      color: "#667eea",
      bgColor: "#667eea22",
    },
    {
      title: "Paid",
      value: data.paid,
      icon: <CheckCircle sx={{ fontSize: 32 }} />,
      color: "#52c41a",
      bgColor: "#52c41a22",
    },
    {
      title: "Pending",
      value: data.sent + data.viewed,
      icon: <Pending sx={{ fontSize: 32 }} />,
      color: "#faad14",
      bgColor: "#faad1422",
    },
    {
      title: "Overdue",
      value: data.overdue,
      icon: <Warning sx={{ fontSize: 32 }} />,
      color: "#ff4d4f",
      bgColor: "#ff4d4f22",
    },
  ];

  return (
    <Box sx={{ mb: 4 }}>
      <Grid container spacing={3}>
        {statCards.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                height: "100%",
                transition: "transform 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 4,
                },
              }}
            >
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                  }}
                >
                  <Box>
                    <Typography
                      color="text.secondary"
                      variant="body2"
                      gutterBottom
                    >
                      {stat.title}
                    </Typography>
                    <Typography variant="h4" fontWeight="bold">
                      {stat.value}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      p: 1.5,
                      borderRadius: 2,
                      bgcolor: stat.bgColor,
                      color: stat.color,
                    }}
                  >
                    {stat.icon}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default InvoiceStats;
